export * from "./partners.selectors";
